import React, { FC, useState } from 'react';

import { Snackbar, Typography } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { LearnerInfo } from '../../../../types';
import { CardSection } from '../../components/CardSection';
import { CardTitle } from '../../components/CardTitle';
import { OrganizationForm } from '../../components/OrganizationForm';
import { OrganizationView } from '../../components/OrganizationView';
import useStyles from './styles';

interface MyOrganisationPageProps {
  userInfo?: LearnerInfo;
  tenantTitle?: string | null;
}

const MyOrganisationPage: FC<MyOrganisationPageProps> = ({ userInfo, tenantTitle }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [formEnabled, setFormEnabled] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const hideAlert = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  return (
    <>
      <Helmet>
        <title>
          {t('page.account.myOrganization')} - {tenantTitle}
        </title>
      </Helmet>
      <CardTitle title={t('page.account.myOrganization')} />
      <CardSection
        title={t('page.account.settings')}
        text={[t('page.account.settingsTextFirst'), t('page.account.settingsTextSecond')]}
      >
        {formEnabled ? (
          <OrganizationForm
            companyLogo={userInfo?.company?.logo_url}
            companyShortName={userInfo?.company?.short_name}
            setFormEnabled={setFormEnabled}
            setOpenAlert={setOpenAlert}
          />
        ) : (
          <OrganizationView
            setFormEnabled={setFormEnabled}
            companyLogo={userInfo?.company?.logo_url}
            companyShortName={userInfo?.company?.short_name}
          />
        )}
      </CardSection>
      <CardSection
        title={t('page.account.organizationInformation')}
        text={[t('page.account.organizationText')]}
      >
        <div>
          <div className={classes.infoBlock}>
            <Typography className={classes.infoTitle}>{t('page.account.name')}</Typography>
            <Typography className={classes.infoText}>{userInfo?.company?.name}</Typography>
          </div>
          <div className={classes.infoBlock}>
            <Typography className={classes.infoTitle}>
              {t('page.account.representative')}
            </Typography>
            <Typography className={classes.infoText}>{userInfo?.name}</Typography>
            <Typography className={classes.infoText}>{userInfo?.email}</Typography>
          </div>
        </div>
      </CardSection>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={hideAlert}>
        <MuiAlert elevation={6} variant="filled" onClose={hideAlert} severity="success">
          {t('alert.saved')}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default MyOrganisationPage;
